import { useState, useEffect, useCallback, useRef } from 'react'

const useTitleHasTooltip = () => {
  const [displayTooltip, setDisplayTooltip] = useState(false)
  const titleContentRef = useRef<HTMLDivElement>(null)

  const checkTitleContent = useCallback(() => {
    if (!titleContentRef.current) return
    const titleContent = titleContentRef.current
    // only display tooltip while title content is over 2 lines
    // each line height is 22px
    setDisplayTooltip(titleContent.scrollHeight! > 44)
  }, [])

  useEffect(() => {
    checkTitleContent()
  })

  return { displayTooltip, titleContentRef }
}

export default useTitleHasTooltip
